import type { APILibraryTemplateResponseType } from "@/core/data_sources/models/APILibraryTemplate";
import { routeBuilders } from "@/core/router";

import { mockTemplates } from "../data_sources/mock";
import { SYSTEM_CATEGORIES } from "../data_sources/store";

export type CatalogMode = "super-admin";

export const superAdminTemplates = mockTemplates.filter(
  (template) => template.source === "library",
);

export const superFilterSections = [
  {
    items: [
      {
        active: true,
        count: superAdminTemplates.length,
        key: "all",
        label: "All templates",
      },
      {
        count: superAdminTemplates.filter(
          (template) => template.status === "draft",
        ).length,
        key: "draft",
        label: "Drafts",
      },
      {
        count: superAdminTemplates.filter(
          (template) => template.status === "published",
        ).length,
        key: "published",
        label: "Published",
      },
      {
        count: superAdminTemplates.filter(
          (template) => template.status === "archived",
        ).length,
        key: "archived",
        label: "Archived",
      },
    ],
    title: "Quick Filters",
  },
  {
    items: SYSTEM_CATEGORIES.slice(0, 5).map((category) => ({
      count: superAdminTemplates.filter((template) =>
        template.categories?.some((item) => item.name === category.name),
      ).length,
      key: category.name,
      label: category.name,
    })),
    title: "Categories",
  },
] as const;

export function countTemplatesByCategory(category: string) {
  return mockTemplates.filter((template) =>
    template.categories?.some((item) => item.name === category),
  ).length;
}

export function countTemplatesByVertical(vertical: string) {
  return mockTemplates.filter((template) =>
    template.verticals?.some((item) => item.name === vertical),
  ).length;
}

export function getPackPath(_mode: CatalogMode, packId: string) {
  return routeBuilders.superAdminPackDetail(packId);
}

export function getTemplateById(templateId: string | number) {
  return mockTemplates.find(
    (template) => String(template.id) === String(templateId),
  );
}

export function isTemplateItem(
  template: APILibraryTemplateResponseType | undefined,
): template is APILibraryTemplateResponseType {
  return typeof template !== "undefined";
}
